import { Tab, Tabs } from "@mui/material"
import { VolumeIllustrationModel } from "api"
import { useState } from "react"
import styled from "styled-components"
import ImageWithButtons from "../../sections/illustrateSize/ImageWithButtons/ImageWithButtons"
import TabPanel from "./TabPanel"

const StyledTabsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: ${(p) => p.theme.colors.lightGrey};
`
const StyledTabs = styled(Tabs)`
  border-bottom: 1px solid ${(p) => p.theme.colors.lightGrey};
  width: 100%;
  [role="tablist"] {
    justify-content: center;
    button {
      font-size: 18px;
      color: inherit;
      opacity: 0.7;
      &.Mui-selected {
        opacity: 1;
      }
      ${(p) => p.theme.breakpoints.up("md")} {
        min-width: 120px;
      }
    }
    ${(p) => p.theme.breakpoints.down("sm")} {
      justify-content: flex-start;
      button {
        font-size: 16px;
      }
    }
  }
  .MuiTabs-indicator {
    background-color: ${(p) => p.theme.colors.white};
  }
`

function a11yProps(index: any) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  }
}

type TabsComponentPropType = {
  data: VolumeIllustrationModel[]
}

const TabsComponent = ({ data }: TabsComponentPropType) => {
  const [currTab, setCurrTab] = useState(0)
  const handleChange = (event: any, newValue: any) => {
    setCurrTab(newValue)
  }

  return (
    <StyledTabsWrapper>
      <StyledTabs value={currTab} onChange={handleChange} aria-label="tabs">
        <Tab label="חיצוני" {...a11yProps(0)} />
        <Tab label="פנימי" {...a11yProps(1)} />
        <Tab label="תא מטען" {...a11yProps(2)} />
      </StyledTabs>
      {data &&
        data.map((item, index) => (
          <TabPanel key={index} value={currTab} index={index}>
            <ImageWithButtons item={item} index={index} />
          </TabPanel>
        ))}
    </StyledTabsWrapper>
  )
}

export default TabsComponent
